'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isNextMonth.js
// module id = 312
// module chunks = 0